import React, {FC, useCallback, useContext} from 'react';
import {AsyncIdFilterInput} from "./AsyncIdFilterInput";
import {LanguageContext} from "../../../config/ContextConfig";
import {projectStageSelectRoute} from "../../../models/projects/ProjectStage";
import {ProjectFilterInputProps} from "./ProjectFilterInput";

export interface ProjectStageFilterInputProps extends ProjectFilterInputProps {
    projectId: number
}

export const projectStageFilterName = 'projectStageId';

/**
 * ProjectStageFilterInput is a wrapper component around AsyncIdFilterInput
 *
 * it providers a select input to choose the project you want in the dataset from the API backend
 *
 * @see AsyncIdFilterInput
 *
 * @param filterName adds ability to choose your own name for the filter, has to be supported by the backend
 * @param projectId the identifier of the project to fetch stages for the select
 *
 * @constructor
 */
export function ProjectStageFilterInput( props: ProjectStageFilterInputProps ){
    const language = useContext( LanguageContext );

    return (
        <AsyncIdFilterInput
            {...props}
            title={language.projects.rowProjectStage}
            route={ projectStageSelectRoute( props.projectId ) }
            filterName={props.filterName ?? projectStageFilterName }
        />
    );
}